import React from "react";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { contactEmail, twitterScreenName } from "../enums";
import { TwitterTimelineEmbed } from "react-twitter-embed";

const useStyles = makeStyles((theme) => ({
  title: {
    paddingTop: theme.spacing() * 2,
    marginBottom: theme.spacing() * 2,
  },
  section: {
    marginBottom: theme.spacing(),
  },
  middleLink: {
    paddingRight: theme.spacing() * 0.5,
    paddingLeft: theme.spacing() * 0.5,
  },
  leftHomeLink: {
    paddingRight: theme.spacing(),
  },
  rightHomeLink: {
    paddingLeft: theme.spacing(),
  },
  homeLinks: {
    marginTop: theme.spacing() * 3,
  },
  homeLink: {
    marginBottom: theme.spacing() * 2,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0px !important",
      paddingRight: "0px !important",
    },
    position: "relative",
    "& img": {
      width: "100%",
      filter: "brightness(70%)",
    },
    "& h4": {
      color: "#ffffff",
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "100%",
      textAlign: "center",
      transform: "translate(-50%, -50%)",
      userSelect: "none",
    },
  },
  imageContainer: {
    "& img": {
      width: "initial !important",
      maxWidth: "80%",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
  },
}));

const HomeLink = ({ image, text, link, position, target }) => {
  const classes = useStyles();

  return (
    <Grid
      xs={12}
      md={6}
      item
      className={[
        classes.homeLink,
        position === "left"
          ? classes.leftHomeLink
          : position === "right"
            ? classes.rightHomeLink
            : classes.middleLink,
      ].join(" ")}
    >
      {link.startsWith("http") || link.startsWith("javascript") ? (
        <a href={link} {...{ target }}>
          {/* eslint-disable-next-line */}
          <img src={image} />
          <Typography variant="h4">{text}</Typography>
        </a>
      ) : (
        <Link to={link} {...{ target }}>
          {/* eslint-disable-next-line */}
          <img src={image} />
          <Typography variant="h4">{text}</Typography>
        </Link>
      )}
    </Grid>
  );
};

export default () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" className={classes.title}>
        About Us
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <TwitterTimelineEmbed
            sourceType="profile"
            screenName={twitterScreenName}
            options={{ height: 500 }}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography variant="body1" className={classes.section}>
            Gem Mint Submissions is located in Holmdel, NJ. We offer
            simplified card submissions to PSA. We offer all
            available service levels from express and bulk submissions. We
            specialize in pre-submission{" "}
            <Link to="evaluate">card evaluations.</Link>
          </Typography>
          <Typography variant="body1" className={classes.section}>
            Submitting your cards for grading can be an intimidating process,
            especially if you've never done it before. Maybe you pulled a case
            hit and want to get it slabbed? Or you want to maximize the value of
            your PC? But lower cost grading turnaround times are upwards of 1
            year, and express grading costs these days are excessive.
          </Typography>
          <Typography variant="body1" className={classes.section}>
            Gem Mint Submissions provides a seamless and dependable grading
            service to all hobby enthusiasts. Whether you’re a novice or a
            collector getting back into the hobby, let us simplify the process
            for you. Fill out our <Link to="/order">user-friendly form</Link>,
            package your investments carefully, and mail the cards you want
            graded along with a copy of the submission form to our secure PO
            Box.
          </Typography>
          <Typography variant="body1" className={classes.section}>
            Any questions? Email us at{" "}
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>. See some of
            our past submissions <Link to="/gallery">here</Link>.
          </Typography>
          <Typography variant="body1" className={classes.section}>
            <strong>Mailing Address:</strong>
          </Typography>
          <Typography variant="body1" className={classes.section}>
            GMS
            <br />
            10 Crawfords Corner Road
            <br />
            PO Box 288
            <br />
            Holmdel, NJ 07733
          </Typography>
        </Grid>
      </Grid>
      <Grid container className={classes.homeLinks}>
        <HomeLink
          image="/images/eval.jpg"
          text="Evaluation"
          link="/evaluate"
          position="left"
        />
        <HomeLink
          image="/images/mail.jpg"
          text="Turnaround Times"
          link="/turnaround-times"
          position="right"
        />
        <HomeLink
          image="/images/submit.jpg"
          text="Start Submission"
          link="/order"
          position="left"
        />
        <HomeLink
          image="/images/eu-grading.png"
          text="Submission Gallery"
          link="/gallery"
          position="right"
        />
      </Grid>
    </>
  );
};
